// extracted by mini-css-extract-plugin
export var acitonButtons = "_30-0";
export var additionalIcon = "_30-f";
export var block = "_30-1";
export var blockContent = "_30-7";
export var blockDescription = "_30-8";
export var blockIcon = "_30-9";
export var blockTitle = "_30-6";
export var border = "_30-a";
export var center = "_30-l";
export var edge = "_30-b";
export var edgeLabel = "_30-c";
export var edgePath = "_30-d";
export var error = "_30-e";
export var flowchart = "_30-g";
export var flowchartContent = "_30-h";
export var highlighted = "_30-3";
export var hover = "_30-4";
export var icon = "_30-i";
export var left = "_30-m";
export var navButton = "_30-j";
export var navButtons = "_30-k";
export var right = "_30-n";
export var selected = "_30-2";
export var small = "_30-5";